import { Box, Button, Divider, Typography } from '@mui/material';
import { ProfileIcon } from '@tix-ticketing/ui-icons/filled';
import { EntranceIcon } from '@tix-ticketing/ui-icons/outline';
import type { ReactNode } from 'react';
import { ActionsMenu } from '../components/actions-menu';
import { IconButton } from '../components/button/icon-button';
import { UserAvatar } from '../components/user-avatar';
import { useIsMobile } from '../hooks/use-is-mobile';
interface UserButtonProps {
  /** Initials shown on the trigger and, on mobile, in the menu header. Falls back to a person icon when empty. */
  initials: string;
  /** Accessible name for the trigger, which shows only initials or an icon. */
  ariaLabel: string;
  name: ReactNode;
  email: ReactNode;
  /** Menu items rendered between the account info and the sign-out button. */
  actions: ReactNode;
  signOutLabel: ReactNode;
  onSignOut: () => void;
}
export function UserButton({
  initials,
  ariaLabel,
  name,
  email,
  actions,
  signOutLabel,
  onSignOut
}: UserButtonProps) {
  const isMobile = useIsMobile();
  return <Box sx={{
    ml: {
      xs: 2,
      sm: 0
    }
  }}>
      <ActionsMenu button={<IconButton variant="contained" label={ariaLabel} sx={{
      fontSize: 16,
      fontWeight: 700
    }}>
            {initials || <ProfileIcon />}
          </IconButton>}>
        <Box sx={{
        p: 1,
        minWidth: 290
      }}>
          <Box sx={{
          display: 'flex',
          gap: 1.5,
          alignItems: 'center'
        }}>
            {isMobile && <UserAvatar initials={initials} />}
            <Box>
              <Typography variant="body1Bold">{name}</Typography>
              <Typography variant="body3" color="text.secondary">
                {email}
              </Typography>
            </Box>
          </Box>
          <Divider sx={{
          my: 2
        }} />
          {actions}
          <Box sx={{
          pt: 2
        }}>
            <Button variant="contained" color="monochrome" fullWidth endIcon={<EntranceIcon />} onClick={onSignOut}>
              {signOutLabel}
            </Button>
          </Box>
        </Box>
      </ActionsMenu>
    </Box>;
}